import React from 'react';
import LoginComponent from '../components/Auth/Login';

const Login: React.FC = () => {
  return <LoginComponent />;
};

export default Login;